<div class="modal fade" id="addConfiguration" data-bs-backdrop="static" tabindex="-1"
  aria-labelledby="addConfigurationModalLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="modal-title fs-5" id="addConfigurationModalLabel">New Configuration</h1>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <form [formGroup]="ConfigForm" (ngSubmit)="onSubmit()" class="form-holder">
          <div class="mb-3">
            <label for="ProviderName" class="col-form-label">FlagName :</label>
            <input type="text" [readOnly]="ConfigForm.value.id" class="form-control" formControlName="flagName"
              id="ProviderName" name="ProviderName" />
          </div>
          <div class="mb-3">
            <label for="token" class="col-form-label">Value :</label>
            <textarea class="form-control" id="token" formControlName="value"></textarea>
          </div>
          <div class="mb-3 ">
            <label for="checkActive" class="col-form-label align-center">IsActive : </label>
            <input type="checkbox" name="checkAcctive" class="m-3" formControlName="isActive" id="checkActive" />
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal"
              (click)="ConfigForm.reset()">Close</button>
            <button type="submit" class="btn btn-primary" data-bs-dismiss="modal" [disabled]="ConfigForm.invalid">
              <ng-container *ngIf=" !ConfigForm.value.id; else subruleText">
                Add
              </ng-container>
              <ng-template #subruleText> Update </ng-template>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
<div class="content-wrapper">
  <div class="page-heading d-flex align-items-center gap-4">
    <h2>Name : {{UserDEtails.firstName + '\t' + UserDEtails.lastName}}</h2>
    <p class="mb-0">User ID : {{UserDEtails.tokenValue.unique_name}}</p>
    <button type="button" class="btn btn-primary add-common-button justify-content-end" data-bs-toggle="modal"
      data-bs-target="#addConfiguration"><i class="bi bi-plus-circle"></i> <span> Add Configuration</span></button>
  </div>
  <div class="card">
    <div class="card-header">
      <h2 class="table-ttl">Configurations :</h2>
    </div>
    <div class="card-body">
      <table class="table table-bordered">
        <thead>
          <tr>
            <th>Flag Name</th>
            <th>Value</th>
            <th>Activation</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let configuration of Configurations" [ngClass]="configuration.isActive ? 'bg-warning':''">
            <td class="text-break">{{configuration.flagName}}</td>
            <td class="text-break">{{configuration.value}}</td>
            <td class="text-center">
              <input type="checkbox" class="btn btn-primary" [checked]="configuration.isActive"
                (change)="onActive(configuration)">
            </td>
            <td>
              <button type="button" class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#addConfiguration"
                (click)="onEditClick(configuration)"> <i class="fa-duotone fa-solid fa-pen-to-square"></i><span>
                  Edit</span></button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div *ngIf="isLoading">
    <app-loader></app-loader>
  </div>
</div>